define 'controller/CustomerFormController', ['jquery', 'lib/kryptonite', 'lib/easy-autocomplete'], ($) ->
  class CustomerFormController

    constructor: (@$el) ->
      @_autocompleteZip()
      @_autocompleteFirstName()
      @_autocompleteMail()
      @_reloadautocompleteFirstName()

    _autocompleteZip: ->
      self = @
      $el = $('#inputRegistrationPostalCode')
      if $el.length > 0
        options =
          url: (phrase) ->
            $el.data('url') + '?q=' + phrase + '&format=json'
          getValue: (element) ->
            element.zip
          template:
            type: 'custom'
            method: (value, item) ->
              if item.location
                "<span class='zip'>" + item.zip + "</span> <span class='city'>" + item.city + "</span> <span class='location'>" + item.location + '</span>'
              else
                "<span class='zip'>" + item.zip + "</span> <span class='city'>" + item.city + '</span>'
          list:
            maxNumberOfElements: 10
            match:
              enabled: true

            onClickEvent: ->
              selectedCity = $el.getSelectedItemData().city
              $('#inputRegistrationCity').val(selectedCity)
              $('#inputRegistrationCity').addClass('active')
              $('#inputRegistrationCity').closest('.input-field').find('label').addClass('active')

              selectedZip = $el.getSelectedItemData().zip
              $el.val(selectedZip)

              if $el.getSelectedItemData().location
                selectedLocation = $el.getSelectedItemData().location
                $('#inputRegistrationTower').val(selectedLocation)
                $('#inputRegistrationTower').addClass('active')
                $('#inputRegistrationTower').closest('.input-field').find('label').addClass('active')

              else if !$('#inputRegistrationTower').val()?
                $('#inputRegistrationTower').val('')

            onKeyEnterEvent: ->
              selectedCity = $('#eac-container-zip .selected .city').text()
              $('#inputRegistrationCity').val(selectedCity)
          requestDelay: 150
          minCharNumber: 4
        $el.easyAutocomplete(options)

    _autocompleteFirstName: ->
      self = @
      $el = $('#inputRegistrationFirstName')
      if $el.length > 0
        salutation = $('[name="salutation"]:checked').val()
        salutationQuery = ''
        if salutation != ''
          salutationQuery = '&salutation=' + salutation
        options =
          url: (phrase) ->
            $el.data('url') + '?firstName=' + phrase + salutationQuery + '&format=json'
          getValue: (element) ->
            element.firstName
          list:
            match:
              enabled: true
            onClickEvent: ->
            onKeyEnterEvent: ->
          requestDelay: 150
          minCharNumber: 2
        $el.easyAutocomplete(options)

    _reloadautocompleteFirstName: ->
      $('.registration').on 'change', '[name="salutation"]', (e) ->
        CustomerFormController.prototype._autocompleteFirstName()
        ## TODO - function call

    _autocompleteMail: ->
      self = @
      $el = $('#inputRegistrationMail')
      if $el.length > 0
        firstName = $('#inputRegistrationFirstName').val()
        lastName = $('#inputRegistrationName').val()
        options =
          url: (phrase) ->
            $el.data('url') + '?firstName=' + firstName + '&lastName=' + lastName + '&email=' + phrase + '&format=json'
          getValue: (element) ->
            element.mailAddress
          list:
            maxNumberOfElements: 10
            match:
              enabled: true
            onClickEvent: ->
            onKeyEnterEvent: ->
          requestDelay: 150
          minCharNumber: 1
        $el.easyAutocomplete(options)

    destroy: ->
      @$el.off()
